import { useEffect, useRef, useState } from 'react';

/**
 * Fires once when the attached element enters the viewport.
 * Returns { ref, isVisible } — attach ref to any DOM element.
 */
/** Defaults tuned so reveals fire while content is still comfortably in view (less “empty until scroll”). */
export default function useScrollReveal({ threshold = 0.06, rootMargin = '0px 0px -10% 0px' } = {}) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold, rootMargin }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, rootMargin]);

  return { ref, isVisible };
}
